module.exports = __webpack_public_path__ + "img/source_gf-02.e0d1c803.png";